import React from 'react'
import { DurationIcon, LightbulbIcon } from '@/src/renderer/components/icons'
import { formatDuration } from '../../utils/parseDuration'
import './TaskDurationBadge.scss'
import type { TaskDurationBadgeProps } from './TaskDurationBadge.types'

export function TaskDurationBadge({ minutes, mode }: TaskDurationBadgeProps) {
  return (
    <span className="task-duration-badge">
      {mode === 'thinking' ? <LightbulbIcon size={16} /> : <DurationIcon size={16} />}
      <span className="task-duration-badge__text">
        {formatDuration(minutes)}
      </span>
    </span>
  )
}
